var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        visible: _vm.showDialog,
        title: _vm.translations.title,
        primaryAction: _vm.primaryAction,
        secondaryActions: _vm.secondaryActions,
        size: "small"
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
        _vm._v("\n        " + _vm._s(_vm.translations.message) + "\n    ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }